import LogoImage from './image/logo.png'

export const logoImage = LogoImage